import React from 'react'
import { ReactComponent } from './pdf.svg'
import { MergeReactElementProps } from '../types'

interface PdfProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', PdfProps>

export const Pdf = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#9a9a9a' } = props
    return <ReactComponent stroke={color} fill={color} ref={ref} {...props} />
  }
)
